import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import productsService from "./productsService";

// @****************************************@
// ---------------Initial state ----
// @****************************************@
const initialState = {
    products: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}


// @****************************************@
// ---------------GET ALL PRODUCTS ----
// @****************************************@

export const getAllProducts = createAsyncThunk('productsList/getAllProducts', async (cat, thunkAPI) => {
    try {
        return await productsService.getProducts(cat)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})








// @****************************************@
// ---------------SLICE ----
// @****************************************@


export const productsSlice = createSlice({
    name: 'productsList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllProducts.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllProducts.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.products = action.payload
            })
            .addCase(getAllProducts.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.products = []
            })
    }
})






// @****************************************@
// ---------------EXPORT ACTIONS AND SLCE ----
// @****************************************@

// export const { } = productsSlice.actions
export default productsSlice.reducer